// extracted by mini-css-extract-plugin
module.exports = {"container":"styles-module__container___1PJqv","checkbox":"styles-module__checkbox___4hsmA"};